import { throttle } from 'es-toolkit';
import { useEffect, useMemo, useState } from 'react';

import SimplifiedMic from '~/modules/game-engine/input/simplified-mic';

// The phone's own hearing, normalised. `SimplifiedMic` reports a raw volume whose useful range
// depends on the microphone and the room, so the loudest thing heard so far is the ceiling and it
// decays - otherwise one cough would flatten the meter for the rest of the song.
export default function useMicLevel() {
  const [volume, setVolume] = useState(0);
  const [frequency, setFrequency] = useState(0);
  const [maxVolume, setMaxVolume] = useState(0.000001);

  const update = useMemo(
    () =>
      throttle((freq: number, nextVolume: number) => {
        setFrequency(freq);
        setVolume(nextVolume);
      }, 150),
    [],
  );

  useEffect(() => {
    SimplifiedMic.startMonitoring();
    return SimplifiedMic.addListener(update);
  }, [update]);

  useEffect(() => {
    setMaxVolume((current) => (volume > current ? volume : current * 0.99));
  }, [volume]);

  return { volume, frequency, level: Math.min(1, volume / maxVolume) };
}
